import React from "react";
import NavigationMenuToolsCrm from "./crm-menu";
import {MenuComponentProps} from "../const";


export default class NavigationMenu_CrmContent extends React.Component<MenuComponentProps, any> {


    render() {

        return (<NavigationMenuToolsCrm navigationSection={this.props.section}/>)
    }
}
